import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { observable, toJS } from 'mobx';
import FetchView from '../../dumb/FetchView/FetchView';
import { Table, TableCell, TableHead, TableBody, TableRow, IconButton } from '@material-ui/core';
import { Container, Modal, Form, Button } from 'react-bulma-components';
import { Accordion, AccordionSummary, AccordionDetails, Typography, MenuItem, TextField, Grid } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClearIcon from '@material-ui/icons/Clear';
import NavigationBar from '../NavigationBar/NavigationBar';
import moment from 'moment';
import AccountsStore from 'stores/AccountsOverview/AccountsStore';
import AccountEditor from './Modal/AccountEditor';
import AccountCreate from './Modal/AccountCreate';
import { toLower } from 'lodash';
import {CsvBuilder} from 'filefy';

const { Input } = Form;

@observer
class AccountList extends Component {
    @observable accessor localstate = {
        search: '',
        filters: {
            group: '',
            channel: '',
            listing_type: '',
            managedBy: '',
            bc_tax_country: '',
            bc_gln: '',
            bc_warehouse_location: '',
            pos_closed: { operator: '=', value: '' },
            pos_potential: { operator: '=', value: '' },
            forecast_revenue: { operator: '=', value: '' },
            closed_listings_count: { operator: '=', value: '' },
        },
        selectedAccount: null,
        isEditorOpen: false,
        isCreateOpen: false,
    };

    editAccount = (account) => {
        console.log('Editing account:', account);
        this.localstate.selectedAccount = account;
        this.localstate.isEditorOpen = true;
    };

    closeEditor = () => {
        console.log('Closing editor');
        this.localstate.isEditorOpen = false;
    };

    openCreateModal = () => {
        this.localstate.isCreateOpen = true;
    };

    closeCreateModal = () => {
        this.localstate.isCreateOpen = false;
    };

    handleAccountFound = (account) => {
        this.localstate.selectedAccount = account;
        this.localstate.isCreateOpen = false;
        this.localstate.isEditorOpen = true;
    };

    filterList(account) {
        let { search, filters } = this.localstate;
        const deleted = account.soft_deleted;

        if (filters.group && account.AccountsOverviewGroup?.name !== filters.group) return !deleted && false;
        if (filters.channel && account.channel !== filters.channel) return !deleted && false;
        if (filters.listing_type && account.listing_type !== filters.listing_type) return !deleted && false;
        if (filters.managedBy && account.AccountsOverviewManager?.name !== filters.managedBy) return !deleted && false;
        if (filters.bc_tax_country && account.bc_tax_country !== filters.bc_tax_country) return !deleted && false;
        if (filters.bc_warehouse_location && account.bc_warehouse_location !== filters.bc_warehouse_location) return !deleted && false;
        if (filters.pos_closed.value && !this.compareValues(account.pos_closed, filters.pos_closed.operator, parseInt(filters.pos_closed.value))) return !deleted && false;
        if (filters.pos_potential.value && !this.compareValues(account.pos_potential, filters.pos_potential.operator, parseInt(filters.pos_potential.value))) return !deleted && false;
        if (filters.forecast_revenue.value && !this.compareValues(account.forecast_revenue, filters.forecast_revenue.operator, parseInt(filters.forecast_revenue.value))) return !deleted && false;
        if (filters.closed_listings_count.value && !this.compareValues(account.closed_listings_count, filters.closed_listings_count.operator, parseInt(filters.closed_listings_count.value))) return !deleted && false;

        if (search) {
            search = search.toLowerCase();
            if (
                (account.number && account.number.includes(search)) ||
                (account.bc_bill_name && account.bc_bill_name.toLowerCase().includes(search))
            ) return !deleted && true;
            return !deleted && false;;
        }

        return !deleted && true;
    }

    compareValues(value, operator, comparisonValue) {
        switch (operator) {
            case '<=':
                return value <= comparisonValue;
            case '<':
                return value < comparisonValue;
            case '=':
                return value === comparisonValue;
            case '>':
                return value > comparisonValue;
            case '>=':
                return value >= comparisonValue;
            default:
                return false;
        }
    }

    onSearchChange(v) {
        this.localstate.search = v;
    }

    onFilterChange = (key, value) => {
        this.localstate.filters[key] = value;
    };

    onNestedFilterChange = (key, subKey, value) => {
        this.localstate.filters[key][subKey] = value;
    };

    clearNestedFilter = (key) => {
        this.localstate.filters[key].operator = '=';
        this.localstate.filters[key].value = '';
    };

    clearFilter = (key) => {
        this.localstate.filters[key] = '';
    };

    clearAllFilters = () => {
        this.localstate.filters = {
            group: '',
            channel: '',
            listing_type: '',
            managedBy: '',
            discount: '',
            bc_tax_country: '',
            bc_warehouse_location: '',
            closed_listings_count: { operator: '=', value: '' },
            pos_closed: { operator: '=', value: '' },
            pos_potential: { operator: '=', value: '' },
            forecast_revenue: { operator: '=', value: '' },
        };
    };

    renderTableCell = (item, key) => {
        let value = item[key];
        const associationKey = association_mapper[key];
        if (associationKey) {
            return item[key]?.[associationKey] || '';
        }
        if (key === 'switch_central_delivery' && value) {
            value = moment(value).format('DD.MM.YYYY');
        }
        return value;
    };

    renderStickyTableCell = (item, key, index) => { //consider alignment with listings
        return (
            <TableCell
                key={index}
                style={{
                    position: 'sticky',
                    left: index * 150,
                    background: '#fff',
                    zIndex: 2,
                    minWidth: '150px',
                    maxWidth: '150px',
                    padding: '6px 12px',
                    textAlign: 'center',
                    borderRight: index === sticky_cols.length - 1 ? '1px solid #ddd' : 'none',
                    whiteSpace: 'normal',
                }}
            >
                {key === 'number' ? (
                    <Button 
                        onClick={() => this.editAccount(item)} 
                        style={{ 
                            padding: 0, 
                            minWidth: 'auto', 
                            textTransform: 'none', 
                            color: 'blue', 
                            textDecoration: 'underline', 
                            fontWeight: 'bold', 
                            border: 'none' 
                        }}
                    >
                        {item[key]}
                    </Button>
                ) : (
                    this.renderTableCell(item, key)
                )}
            </TableCell>
        );
    };

    export = () => {
        const filtered = AccountsStore.list?.accounts?.filter(this.filterList.bind(this));
        const csvBuilder = new CsvBuilder(`accounts-overview_${moment().format('DDMMYYYY')}.csv`)
        .setColumns([
            'Group',
            'Account bill name',
            'Debitor no',
            'Channel',
            'Type of Listing',
            'Tax Country',
            'SKUs listed',
            'POS Potential',
            'Forecast revenue',
            'Managed by',
            'Discount rate',
            'Warehouse location',
            'Invoice GLN',
            'Invoice GLN',
            'POS closed',
        ]);

        for (const item of filtered) {
            const {AccountsOverviewGroup, bc_bill_name, number, channel, listing_type, bc_tax_country, closed_listings_count, pos_potential, forecast_revenue, AccountsOverviewManager, discount, bc_warehouse_location, bc_gln, switch_central_delivery, pos_closed} = item;
            csvBuilder.addRow([
                AccountsOverviewGroup?.name || '',
                bc_bill_name || '',
                number || '',
                channel || '',
                listing_type || '',
                bc_tax_country || '',
                closed_listings_count || '',
                pos_potential || '',
                forecast_revenue || '',
                AccountsOverviewManager?.name || '',
                discount || '',
                bc_warehouse_location || '',
                bc_gln || '',
                switch_central_delivery || '',
                pos_closed || '',
            ]);
        }

        csvBuilder.exportFile();
    };

    render() {
        const { search } = this.localstate;

        return (
            <>
                {/* Header */}
                <NavigationBar title="Accounts">
                    <Button onClick={this.openCreateModal}>Add account</Button>
                </NavigationBar>

                <Container style={{ marginTop: '20px', overflowX: 'auto', maxWidth: '90%' }}>
                    <FetchView stores={[AccountsStore]}>

                        {/* Collapsible Filter Component */}
                        <Accordion style={{ marginBottom: '35px' }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography style={{ fontWeight: 'bold' }}>Filter Options</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>

                                    {/* Group Dropdown */}
                                    <Grid item xs={4} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Group"
                                            value={this.localstate.filters.group}
                                            onChange={(e) => this.onFilterChange('group', e.target.value)}
                                            fullwidth
                                        >
                                            {AccountsStore?.list.groups?.map((group) => (
                                                <MenuItem key={group.id} value={group.name}>
                                                    {group.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.localstate.filters.group && (
                                            <IconButton
                                                onClick={() => this.clearFilter('group')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '60%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '3px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* Channel Dropdown */}
                                    <Grid item xs={4} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Channel"
                                            value={this.localstate.filters.channel}
                                            onChange={(e) => this.onFilterChange('channel', e.target.value)}
                                            fullwidth
                                        >
                                            {AccountsStore.channels.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.localstate.filters.channel && (
                                            <IconButton
                                                onClick={() => this.clearFilter('channel')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '60%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '3px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* Type of Listing Dropdown */}
                                    <Grid item xs={4} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Type of Listing"
                                            value={this.localstate.filters.listing_type}
                                            onChange={(e) => this.onFilterChange('listing_type', e.target.value)}
                                            fullwidth
                                        >
                                            {AccountsStore.listingTypes.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.localstate.filters.listing_type && (
                                            <IconButton
                                                onClick={() => this.clearFilter('listing_type')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '60%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '3px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* Managed By Dropdown */}
                                    <Grid item xs={4} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Managed By"
                                            value={this.localstate.filters.managedBy}
                                            onChange={(e) => this.onFilterChange('managedBy', e.target.value)}
                                            fullwidth
                                        >
                                            {AccountsStore?.list.managers?.map((manager) => (
                                                <MenuItem key={manager.id} value={manager.name}>
                                                    {manager.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.localstate.filters.managedBy && (
                                            <IconButton
                                                onClick={() => this.clearFilter('managedBy')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '60%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '3px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* Tax Country Dropdown */}
                                    <Grid item xs={4} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Tax Country"
                                            value={this.localstate.filters.bc_tax_country}
                                            onChange={(e) => this.onFilterChange('bc_tax_country', e.target.value)}
                                            fullwidth
                                        >
                                            {AccountsStore.taxCountries?.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.localstate.filters.bc_tax_country && (
                                            <IconButton
                                                onClick={() => this.clearFilter('bc_tax_country')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '60%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '3px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* Warehouse Location Dropdown */}
                                    <Grid item xs={4} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Warehouse location"
                                            value={this.localstate.filters.bc_warehouse_location}
                                            onChange={(e) => this.onFilterChange('bc_warehouse_location', e.target.value)}
                                            fullwidth
                                        >
                                            {AccountsStore?.warehouseLocations?.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.localstate.filters.bc_warehouse_location && (
                                            <IconButton
                                                onClick={() => this.clearFilter('bc_warehouse_location')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '60%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '3px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* SKUs Listed Filter */}
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="SKUs Listed"
                                            value={this.localstate.filters.closed_listings_count.operator}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('closed_listings_count', 'operator', e.target.value)
                                            }
                                            fullwidth
                                        >
                                            {['<=', '<', '=', '>', '>='].map((op) => (
                                                <MenuItem key={op} value={op}>
                                                    {op}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            label="Value"
                                            type="number"
                                            value={this.localstate.filters.closed_listings_count.value}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('closed_listings_count', 'value', e.target.value)
                                            }
                                            fullwidth
                                        />
                                        {this.localstate.filters.closed_listings_count.value && (
                                            <IconButton
                                                onClick={() => this.clearNestedFilter('closed_listings_count')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '4px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* POS Closed Filter */}
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="POS closed"
                                            value={this.localstate.filters.pos_closed.operator}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('pos_closed', 'operator', e.target.value)
                                            }
                                            fullwidth
                                        >
                                            {['<=', '<', '=', '>', '>='].map((op) => (
                                                <MenuItem key={op} value={op}>
                                                    {op}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            label="Value"
                                            type="number"
                                            value={this.localstate.filters.pos_closed.value}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('pos_closed', 'value', e.target.value)
                                            }
                                            fullwidth
                                        />
                                        {this.localstate.filters.pos_closed.value && (
                                            <IconButton
                                                onClick={() => this.clearNestedFilter('pos_closed')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '4px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* POS Potential Filter */}
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="POS Potential"
                                            value={this.localstate.filters.pos_potential.operator}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('pos_potential', 'operator', e.target.value)
                                            }
                                            fullwidth
                                        >
                                            {['<=', '<', '=', '>', '>='].map((op) => (
                                                <MenuItem key={op} value={op}>
                                                    {op}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            label="Value"
                                            type="number"
                                            value={this.localstate.filters.pos_potential.value}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('pos_potential', 'value', e.target.value)
                                            }
                                            fullwidth
                                        />
                                        {this.localstate.filters.pos_potential.value && (
                                            <IconButton
                                                onClick={() => this.clearNestedFilter('pos_potential')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '4px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>

                                    {/* Forecast Revenue filter */}
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            select
                                            label="Forecast Revenue"
                                            value={this.localstate.filters.forecast_revenue.operator}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('forecast_revenue', 'operator', e.target.value)
                                            }
                                            fullwidth
                                        >
                                            {['<=', '<', '=', '>', '>='].map((op) => (
                                                <MenuItem key={op} value={op}>
                                                    {op}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={2} style={{ position: 'relative', width: '80%' }}>
                                        <TextField
                                            label="Value"
                                            type="number"
                                            value={this.localstate.filters.forecast_revenue.value}
                                            onChange={(e) =>
                                                this.onNestedFilterChange('forecast_revenue', 'value', e.target.value)
                                            }
                                            fullwidth
                                        />
                                        {this.localstate.filters.forecast_revenue.value && (
                                            <IconButton
                                                onClick={() => this.clearFilter('forecast_revenue')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#ccc',
                                                    borderRadius: '50%',
                                                    padding: '4px',
                                                }}
                                                title="Clear value"
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Grid>
                                </Grid>
                                <Button 
                                    onClick={this.clearAllFilters} 
                                    style={{ 
                                        height: '100%', 
                                        backgroundColor: '#f0f0f0', 
                                        border: 'none', 
                                        color: '#4a4a4a' 
                                    }}
                                >
                                    Clear All Filters
                                </Button>
                            </AccordionDetails>
                        </Accordion>

                        {/* Search Bar */}
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                            <Input
                                onChange={(e) => this.onSearchChange(e.target.value)}
                                value={search}
                                placeholder="Search..."
                                style={{
                                    marginBottom: '20px',
                                }}
                            />
                        </div>
                        <div>
                            <Button onClick={this.export}>CSV export</Button>
                        </div>

                        <Container style={{ marginTop: '20px', overflowX: 'auto', maxWidth: '100%', position: 'relative' }}>
                            {/* Table */}
                            <Table
                                style={{
                                    borderSpacing: '0px',
                                    tableLayout: 'auto',
                                    whiteSpace: 'nowrap',
                                    width: 'max-content',
                                }}
                                aria-label="simple table"
                                stickyHeader
                            >
                                <TableHead>
                                    <TableRow>
                                        {Object.keys(col_mapper).map((header, index) => (
                                            <TableCell
                                                key={index}
                                                style={{
                                                    padding: '6px 12px',
                                                    fontWeight: 'bold',
                                                    background: '#f9f9f9',
                                                    position: index < sticky_cols.length ? 'sticky' : 'static', // Make first 3 columns sticky
                                                    left: index < sticky_cols.length ? (index * 150)  + 'px' : 'auto', // Adjust sticky positions
                                                    zIndex: index < sticky_cols.length ? sticky_cols.length : 1, 
                                                    minWidth: index < sticky_cols.length ? '150px' : 'auto',
                                                    textAlign: 'center',
                                                    borderRight:index === sticky_cols.length - 1 ? '1px solid #ddd' : 'none',
                                                }}
                                            >
                                                {header}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {(AccountsStore?.list?.accounts || [])
                                        .filter(this.filterList.bind(this))
                                        .sort((a,b) => a.bc_tax_country === b.bc_tax_country ? (toLower(a.bc_bill_name) < toLower(b.bc_bill_name) ? -1 : 1) : a.bc_tax_country < b.bc_tax_country ? -1 : 1)
                                        .map((item, i) => (
                                            <TableRow key={i}>
                                                {sticky_cols.map((key, index) => this.renderStickyTableCell(item, col_mapper[key], index))}
                                                {Object.keys(col_mapper).slice(sticky_cols.length).map((key, index) => (
                                                    <TableCell
                                                        key={index}
                                                        style={{
                                                            padding: '6px 12px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {this.renderTableCell(item, col_mapper[key])}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </Container>
                    </FetchView>
                </Container>
                <AccountEditor
                    account={this.localstate.selectedAccount}
                    isOpen={this.localstate.isEditorOpen}
                    onClose={this.closeEditor}
                />
                <AccountCreate
                    isOpen={this.localstate.isCreateOpen}
                    onClose={this.closeCreateModal}
                    onAccountFound={this.handleAccountFound}
                    onOpenEditor={this.editAccount} // Pass the openEditor method as a prop
                />
            </>
        );
    }
}

const col_mapper = {
    'Group': 'AccountsOverviewGroup',
    'Account bill name': 'bc_bill_name',
    'Debitor No.': 'number',
    'Channel': 'channel',
    'Type of Listing': 'listing_type',
    'Tax Country': 'bc_tax_country',
    'SKUs listed': 'closed_listings_count',
    'POS Potential': 'pos_potential',
    'Forecast revenue': 'forecast_revenue',
    'Managed by': 'AccountsOverviewManager',
    'Discount rate': 'discount',
    'Warehouse location': 'bc_warehouse_location',
    'Invoice GLN': 'bc_gln',
    'Start Zentralregulierung': 'switch_central_delivery',
    'POS closed': 'pos_closed',
}
const association_mapper = {
    'AccountsOverviewGroup': 'name',
    'AccountsOverviewManager': 'name',
}
const sticky_cols = ['Group', 'Account bill name', 'Debitor No.'];

export default AccountList;
